var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIconInfo = function SvgIconInfo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58192 0 0 3.58192 0 8C0 12.4181 3.58192 16 8 16C12.4181 16 16 12.4181 16 8C16 3.58192 12.4181 0 8 0ZM7.07563 11.4531V7.79056C7.07563 7.28056 7.48938 6.86619 8 6.86619C8.51062 6.86619 8.92437 7.28056 8.92437 7.79056V11.4531C8.92437 11.9637 8.51062 12.3775 8 12.3775C7.48938 12.3775 7.07563 11.9637 7.07563 11.4531ZM8 5.85744C7.55062 5.85744 7.14563 5.58682 6.97374 5.17181C6.80125 4.7568 6.89624 4.27869 7.21437 3.96118C7.53187 3.64306 8.01 3.54806 8.42499 3.71994C8.84062 3.89181 9.11125 4.29744 9.11125 4.74682C9.11125 5.04118 8.99375 5.3237 8.78562 5.53245C8.57749 5.74058 8.29437 5.85744 7.99998 5.85744H8Z",
    fill: "#8E8E93"
  }))));
};
export default SvgIconInfo;